import type { OwnerChangedActivityDetails } from '@paintscout/api'

import React from 'react'
import { formatName } from '@paintscout/util/builder'
import Highlight from '../../Highlight'
import type { ActivityTypeComponentProps } from '../Activity'
import ActivityFooter from '../ActivityFooter'
import ActivityTitle from '../ActivityTitle'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'

export default function QuoteOwnerChangedActivity(props: ActivityTypeComponentProps<OwnerChangedActivityDetails>) {
  const { activity, showDocTypeDetails } = props

  const newOwner = formatName(activity.details.newOwner)

  return (
    <>
      <ActivityTitle>
        <Highlight>Estimator</Highlight> changed to <Highlight>{newOwner ? newOwner : 'No User'}</Highlight>
      </ActivityTitle>
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
